import { Link } from "react-router-dom";

import { Fragment } from "react/jsx-runtime";

import { ETermType } from "@schemas/terms";

import PathContants from "@routers/pathConstants";

import { useTermsStore } from "@stores/termStore";

import "./style.scss";

const Footer = () => {
	const { getTypeByTermsList } = useTermsStore(["terms", "getTypeByTermsList"]);
	const terms = getTypeByTermsList([ETermType.TERMS_OF_SERVICE, ETermType.PRIVACY_POLICY]);
	return (
		<footer className="footer">
			<div className="footer__inner">
				<div className="footer__brand">
					<div className="footer__brand__logo" aria-hidden="true">
						<img src="/images/footer/footer-logo.png" />
					</div>
					<div className="footer__brand__info">
						<p>대표 : 남상욱 ㅣ 사업자등록번호 : 606-58-00508</p>
						<p>주소 : 경기도 안산시 단원구 화정천동로 108, 1층(고잔동)</p>
						<p>
							대표전화 : 000-000-0000 ㅣ 이메일 : nasa4864745@naver.com ㅣ FAX :
							000-000-0000
						</p>
					</div>
				</div>
				<div className="footer__links">
					{terms?.map((term, index) => (
						<Fragment key={index}>
							<Link
								to={`${PathContants.TermsDetail.replace(":id", term.id.toString())}`}
								className="footer__link"
							>
								{term.nameKo}
							</Link>
							{index < terms.length - 1 && (
								<span className="footer__divider" aria-hidden="true">
									ㅣ
								</span>
							)}
						</Fragment>
					))}
				</div>

				<nav className="footer__nav" aria-label="푸터 내비게이션">
					<ul>
						<li>
							<Link to={PathContants.Home}>HOME</Link>
						</li>
						<li>
							<Link to={PathContants.Brand}>BRAND</Link>
						</li>
						<li>
							<Link to={PathContants.Partner}>PARTNER</Link>
						</li>
						<li>
							<Link to={PathContants.SupportNotice}>SUPPORT</Link>
						</li>
					</ul>
				</nav>

				<div className="footer__social" aria-label="소셜 링크">
					<Link to="#" aria-label="Instagram" className="footer__social__item">
						<img src="/images/footer/instagram-icon.png" />
					</Link>
					<Link to="#" aria-label="YouTube" className="footer__social__item">
						<img src="/images/footer/youtube-icon.png" />
					</Link>
					<Link to="#" aria-label="KakaoTalk" className="footer__social__item">
						<img src="/images/footer/kakao-icon.png" />
					</Link>
					<Link to="#" aria-label="Naver" className="footer__social__item">
						<img src="/images/footer/naver-icon.png" />
					</Link>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
